import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function markChildControlsAsTouched(control: AbstractControl) {
  control.markAsTouched();
  control.markAsDirty();
  control.updateValueAndValidity();
  if (control['controls'] != null) {
    Object.values(control['controls']).forEach((childControl: any) => {
      markChildControlsAsTouched(childControl);
    });
  }
}

export function getFieldVisibility(formFields: FormlyFieldConfig[], questionConfig: FormlyFieldConfig, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number): boolean {
  let formControl = getFormControl(formFields, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
  return formControl != null;
}

export function getFormControl(formFields: FormlyFieldConfig[], questionConfig: FormlyFieldConfig, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number): AbstractControl {
  let questionKey = questionConfig.key.toString();

  let tabsControl = formFields?.[0]?.formControl?.['controls']?.tabs?.['controls'];

  if (tabsControl == null) {
    return undefined;
  }

  let formControl: AbstractControl;

  //Non-repeating page and section.
  if (questionConfig.props.isRepeatingPage === false && questionConfig.props.isRepeatingSection === false) {
    formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey]?.controls[questionKey];
  }
  //Else if question in repeating page only.
  else if (questionConfig.props.isRepeatingPage === true && questionConfig.props.isRepeatingSection === false) {
    formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey]?.controls[questionKey];
  }
  //Else if question in repeating section only.
  else if (questionConfig.props.isRepeatingPage === false && questionConfig.props.isRepeatingSection === true) {
    formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey]?.controls[sectionIndex]?.controls[questionKey];
  }
  //Else if question in repeating page and repeating section.
  else if (questionConfig.props.isRepeatingPage === true && questionConfig.props.isRepeatingSection === true) {
    formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey]?.controls[sectionIndex]?.controls[questionKey];
  }

  return formControl;
}

export function getSectionFormControl(formFields: FormlyFieldConfig[], sectionConfig: FormlyFieldConfig, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number): AbstractControl {
  // let questionKey = sectionConfig.key.toString();
  //let formRootControl = this.field.parent.parent.parent.parent.formControl;
  let tabsControl = formFields[0]?.formControl['controls']?.tabs['controls']
  let formControl: AbstractControl;

  //Non-repeating page and section.
  if (sectionConfig.props.isRepeatingPage === null || sectionConfig.props.isRepeatingPage === undefined || sectionConfig.props.isRepeatingPage !== true) {
    formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey];
  }
  //Else if question in repeating page only.
  else if (sectionConfig.props.isRepeatingPage === true) {
    formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey];
  }

  return formControl;
}

export function getPageValue(model: any, tabKey: string, pageKey: string, pageIndex: number) {
  //Repeating page.
  if (pageIndex > -1) {
    return model?.[tabKey]?.[pageKey]?.[pageIndex];
  }
  //Page is are not repeating.
  return model?.[tabKey]?.[pageKey];
}

export function getSectionValue(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number) {
  //Repeating section.
  if (sectionIndex > -1) {
    return getPageValue(model, tabKey, pageKey, pageIndex)?.[sectionKey]?.[sectionIndex];
  }

  //Section is not repeating.
  return getPageValue(model, tabKey, pageKey, pageIndex)?.[sectionKey];
}

export function getResponseValue(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number, questionKey: string) {
  return getSectionValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex)?.[questionKey];
}

export function getRawResponse(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number, questionKey: string) {
  const responseValue = getResponseValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey);
  return typeof responseValue === 'object' && responseValue?.code ? responseValue.code : responseValue?.toString();
}

export function setResponseValue(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number, questionKey: string, questionValue: any) {
  //Repeating page only.
  if (pageIndex > -1 && sectionIndex === -1) {
    if (model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey] != null) {
      model[tabKey][pageKey][pageIndex][sectionKey][questionKey] = questionValue;
    }
  }

  //Repeating section only.
  else if (pageIndex === -1 && sectionIndex > -1) {
    if (model?.[tabKey]?.[pageKey]?.[sectionKey]?.[sectionIndex] != null) {
      model[tabKey][pageKey][sectionKey][sectionIndex][questionKey] = questionValue;
    }
  }

  //Repeating page and repeating section.
  else if (pageIndex > -1 && sectionIndex > -1) {
    if (model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]?.[sectionIndex] != null) {
      model[tabKey][pageKey][pageIndex][sectionKey][sectionIndex][questionKey] = questionValue;
    }
  }

  //Page and section are not repeating.
  else {
    if (model?.[tabKey]?.[pageKey]?.[sectionKey] != null) {
      return model[tabKey][pageKey][sectionKey][questionKey] = questionValue;
    }
  }
}

export function getQuestionAnsweredStatus(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number, questionKey: string): boolean {
  if (model != null) {
    let response = getRawResponse(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey);

    return response !== null && response !== undefined && response !== '' && !isNullOrWhitespaceOnly(response);
  }

  return false;
}

export function isNullOrWhitespaceOnly(input: any) {

  if (typeof input === 'undefined' || input == null) {
    return true;
  }

  return input.toString().replace(/\s/g, '').length < 1;
}

export function findNavTabConfigs(formFields: FormlyFieldConfig[]): FormlyFieldConfig[] {
  return formFields?.[0]?.fieldGroup?.[0]?.fieldGroup;
}

export function findNavTabConfig(formFields: FormlyFieldConfig[], tabKey: string): FormlyFieldConfig{
   return findNavTabConfigs(formFields)?.filter(navTabConfig => navTabConfig.key === tabKey)?.[0];
}

export function findPageConfigs(formFields: FormlyFieldConfig[], tabKey: string): FormlyFieldConfig[]{
  return findNavTabConfig(formFields, tabKey)?.fieldGroup;
}

export function findPageConfig(formFields: FormlyFieldConfig[], tabKey: string, pageKey: string): FormlyFieldConfig{
  return findPageConfigs(formFields, tabKey)?.filter(pageConfig => pageConfig.key === pageKey)?.[0];
}

export function findSectionConfigs(formFields: FormlyFieldConfig[], tabKey: string, pageKey: string): FormlyFieldConfig[] {
  const pageConfig = findPageConfig(formFields, tabKey, pageKey);
  if (pageConfig?.fieldArray != null) {
    return (pageConfig?.fieldArray as FormlyFieldConfig).fieldGroup;
  }
  else {
    return pageConfig?.fieldGroup;
  }
}

export function findSectionConfig(formFields: FormlyFieldConfig[], tabKey: string, pageKey: string, sectionCode: string): FormlyFieldConfig{
   return findSectionConfigs(formFields, tabKey, pageKey)?.filter(sectionConfig => sectionConfig.key === sectionCode)?.[0];
}

export function findQuestionConfigs(formFields: FormlyFieldConfig[], tabKey: string, pageKey: string, sectionCode: string): FormlyFieldConfig[] {
  const sectionConfig = findSectionConfig(formFields, tabKey, pageKey, sectionCode);
  if (sectionConfig?.fieldArray != null) {
    return (sectionConfig?.fieldArray as FormlyFieldConfig).fieldGroup;
  }
  else {
    return sectionConfig?.fieldGroup;
  }
}

export function findQuestionConfig(formFields: FormlyFieldConfig[], tabKey: string, pageKey: string, sectionCode: string, questionCode: string): FormlyFieldConfig {
  return findQuestionConfigs(formFields, tabKey, pageKey, sectionCode)?.filter(questionConfig => questionConfig.key === questionCode)?.[0];
}

export type TabKeyPageKey = {
  tabKey: string;
  pageKey: string;
}

export function getTabPageKeysFromPageId(pageId: string): TabKeyPageKey {
  //Assumes that pageId is in the format <tab number>-<page number>, e.g. 8-2 for tab 8, page 2.
  return {
    tabKey: `tab${pageId.split('-')[0]}`,
    pageKey: `page${pageId.split('-')[1]}`
  }
}
